module.exports = __webpack_public_path__ + "img/IMG_0786.11747c09.jpg";